import Dropzone from "dropzone";
let DZmessages = {
	dictDefaultMessage: 'Seleccione o arrastre los archivos que desea cargar',
	dictFallbackMessage: "Tu navegador no soporta el arrastre de archivos para cargar.",
	dictFallbackText: "Utilice el formato estandar para cargar archivos.",
	dictFileTooBig: "Archivo muy pesado ({{filesize}}Mb). Peso máximo: {{maxFilesize}}Mb.",
	dictInvalidFileType: "No puedes cargar archivos de este tipo.",
	dictResponseError: "El servidor responde con código: {{statusCode}}.",
	dictCancelUpload: "Cancelar carga",
	dictUploadCanceled: "Carga cancelada.",
	dictCancelUploadConfirmation: "¿Estás seguro de cancelar la descarga?",
	dictRemoveFile: "Borrar archivo",
	dictMaxFilesExceeded: "No puedes cargar más archivos.",
};

/** Carga files en Solicitud de materiales */
Dropzone.options.addFiles = {
	paramName: "file", // The name that will be used to transfer the file
	maxFilesize: 5, // MB
	acceptedFiles: 'image/*, application/pdf, application/vnd.ms-excel, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	dictDefaultMessage: DZmessages.dictDefaultMessage,
	dictFallbackMessage: DZmessages.dictFallbackMessage,
	dictFallbackText: DZmessages.dictFallbackText,
	dictFileTooBig: DZmessages.dictFileTooBig,
	dictInvalidFileType: DZmessages.dictInvalidFileType,
	dictResponseError: DZmessages.dictResponseError,
	dictCancelUpload: DZmessages.dictCancelUpload,
	dictUploadCanceled: DZmessages.dictUploadCanceled,
	dictCancelUploadConfirmation: DZmessages.dictCancelUploadConfirmation,
	dictRemoveFile: DZmessages.dictRemoveFile,
	dictMaxFilesExceeded: DZmessages.dictMaxFilesExceeded,
	success: function (file, response){
  		if(file.status == "success"){
	  		handleDropzoneFileUpload.handleSuccess(response);
	  	}else{
			handleDropzoneFileUpload.handleError(response);
	  	}
  	},
  	error: function (file, response){
  		$(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response);
  	},
	init: function(){
	    var dz = this;
	    $('.fullmodal').on('hidden.bs.modal', function () {
	      dz.removeAllFiles();
	    });
	}
}

var handleDropzoneFileUpload = {
	handleError: function(response){

	},
	handleSuccess: function(response){
	    $(".archives_list").append(response);
	}
};

/** Carga files en Nuevo Despacho - GBC*/
Dropzone.options.addGBC = {
	paramName: "file", // The name that will be used to transfer the file
	maxFilesize: 5, // MB
	acceptedFiles: 'image/*, application/pdf',
	maxFiles:1,
	uploadMultiple: false,
	addRemoveLinks: true,
	dictDefaultMessage: DZmessages.dictDefaultMessage,
	dictFallbackMessage: DZmessages.dictFallbackMessage,
	dictFallbackText: DZmessages.dictFallbackText,
	dictFileTooBig: DZmessages.dictFileTooBig,
	dictInvalidFileType: DZmessages.dictInvalidFileType,
	dictResponseError: DZmessages.dictResponseError,
	dictCancelUpload: DZmessages.dictCancelUpload,
	dictUploadCanceled: DZmessages.dictUploadCanceled,
	dictCancelUploadConfirmation: DZmessages.dictCancelUploadConfirmation,
	dictRemoveFile: DZmessages.dictRemoveFile,
	dictMaxFilesExceeded: DZmessages.dictMaxFilesExceeded,
	success: function (file, response){
  		if(file.status == "success"){
  			var dz = this;
	  		handleDropzoneFileUploadGBC.handleSuccess(response,dz);
	  	}else{
			handleDropzoneFileUploadGBC.handleError(response);
	  	}
	},
	error: function (file, response){
  		$(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response);
  	},
	complete: function (file, response){

	}
}

var handleDropzoneFileUploadGBC = {
	handleError: function(response){
	},
	handleSuccess: function(response,dz){
		$("#addGBC").hide();
	    $(".file_gbc").append(response);
	    dz.removeAllFiles();
	}
};

/** Carga files en Nuevo Despacho - GD*/
Dropzone.options.addGD = {
	paramName: "file", // The name that will be used to transfer the file
	maxFilesize: 5, // MB
	acceptedFiles: 'image/*, application/pdf',
	maxFiles:1,
	uploadMultiple: false,
	addRemoveLinks: true,
	dictDefaultMessage: DZmessages.dictDefaultMessage,
	dictFallbackMessage: DZmessages.dictFallbackMessage,
	dictFallbackText: DZmessages.dictFallbackText,
	dictFileTooBig: DZmessages.dictFileTooBig,
	dictInvalidFileType: DZmessages.dictInvalidFileType,
	dictResponseError: DZmessages.dictResponseError,
	dictCancelUpload: DZmessages.dictCancelUpload,
	dictUploadCanceled: DZmessages.dictUploadCanceled,
	dictCancelUploadConfirmation: DZmessages.dictCancelUploadConfirmation,
	dictRemoveFile: DZmessages.dictRemoveFile,
	dictMaxFilesExceeded: DZmessages.dictMaxFilesExceeded,
	success: function (file, response){
  		if(file.status == "success"){
  			var dz = this;
	  		handleDropzoneFileUploadGD.handleSuccess(response,dz);
	  	}else{
			handleDropzoneFileUploadGD.handleError(response);
	  	}
  	},
  	error: function (file, response){
  		$(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response);
  	},
	complete: function (file, response){

	}
}

var handleDropzoneFileUploadGD = {
	handleError: function(response){

	},
	handleSuccess: function(response,dz){
		$("#addGD").hide();
	    $(".file_gd").append(response);
	    dz.removeAllFiles();
	}
};

/** Cargar files OC */
Dropzone.options.addOC = {
	paramName: "file", // The name that will be used to transfer the file
	maxFilesize: 5, // MB
	acceptedFiles: 'image/*, application/pdf',
	maxFiles:1,
	uploadMultiple: false,
	addRemoveLinks: true,
	dictDefaultMessage: DZmessages.dictDefaultMessage,
	dictFallbackMessage: DZmessages.dictFallbackMessage,
	dictFallbackText: DZmessages.dictFallbackText,
	dictFileTooBig: DZmessages.dictFileTooBig,
	dictInvalidFileType: DZmessages.dictInvalidFileType,
	dictResponseError: DZmessages.dictResponseError,
	dictCancelUpload: DZmessages.dictCancelUpload,
	dictUploadCanceled: DZmessages.dictUploadCanceled,
	dictCancelUploadConfirmation: DZmessages.dictCancelUploadConfirmation,
	dictRemoveFile: DZmessages.dictRemoveFile,
	dictMaxFilesExceeded: DZmessages.dictMaxFilesExceeded,
	success: function (file, response){
  		if(file.status == "success"){
  			var dz = this;
	  		handleDropzoneFileUploadOC.handleSuccess(response,dz);
	  	}else{
			handleDropzoneFileUploadOC.handleError(response);
	  	}
  	},
  	error: function (file, response){
  		$(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response);
  	}
}

var handleDropzoneFileUploadOC = {
	handleError: function(response){

	},
	handleSuccess: function(response,dz){
		$("#addOC").hide();
	    $(".file_oc").append(response);
	    dz.removeAllFiles();
	}
};


$(document).ready(function() {
	$('[data-toggle="tooltip"]').tooltip();

	$(".dtable").DataTable({
		paging: true,
		pageLength: 100,
		lengthMenu: [[15, 30, 50, 100, -1], [15, 30, 50, 100, "Todos"]],
		lengthChange: true,
		searching: true,
		ordering: true,
		order: [
			$(".dtable").data("dtable-order") ? $(".dtable").data("dtable-order") : 0,
			"desc"
		],
		info: false,
		autoWidth: false,
		columnDefs: [
			{
				targets: $(".dtable").data("dtable-ignore")
					? $(".dtable").data("dtable-ignore")
					: [],
				orderable: false
			}
		],
		"drawCallback": function () {
			$('.dataTables_paginate > .pagination .active a ').addClass('border-info bg-info');
		},
		language: {
			"sProcessing": "Procesando...",
			"sLengthMenu": "Mostrar _MENU_ registros",
			"sZeroRecords": "No se encontraron resultados",
			"sEmptyTable": "Ningún dato disponible en esta tabla",
			"sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
			"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
			"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
			"sInfoPostFix": "",
			"sSearch": "Buscar:",
			"sUrl": "",
			"sInfoThousands": ",",
			"sLoadingRecords": "Cargando...",
			"oPaginate": {
				"sFirst": "Primero",
				"sLast": "Último",
				"sNext": "Siguiente",
				"sPrevious": "Anterior"
			},
			"oAria": {
				"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
				"sSortDescending": ": Activar para ordenar la columna de manera descendente"
			}
		}
	});
	let main_token = $( "meta[name='csrf-token']" ).attr('content');

	$("#tableMateriales").DataTable({
		// paging: true,
		// pageLength: 100,
		// lengthMenu: [[15, 30, 50, 100, -1], [15, 30, 50, 100, "Todos"]],
		// searching: true,
		"processing": true,
		"serverSide": true,
		"ajax":{
					"url": "/allmaterials",
					"dataType": "json",
					"type": "POST",
					"data":{ _token: main_token}
					},
		"columns": [
				{ "data": "id" },
				{ "data": "code" },
				{ "data": "serie" },
				{ "data": "description" },
				{ "data": "description_2" },
				{ "data": "unit_of_measurement_id" },
				{ "data": "group_id" },
				{ "data": "inventariable" },
				{ "data": "talla" },
				{ "data": "color" },
				{ "data": "edit" }
		],
		columnDefs: [
			{
				targets: $("#tableMateriales").data("dtable-ignore")
					? $("#tableMateriales").data("dtable-ignore")
					: [],
				orderable: false
			}
		],
		ordering: true,
		lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
		lengthChange: true,
		language: {
			"sProcessing": "Procesando...",
			"sLengthMenu": "Mostrar _MENU_ registros",
			"sZeroRecords": "No se encontraron resultados",
			"sEmptyTable": "Ningún dato disponible en esta tabla",
			"sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
			"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
			"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
			"sInfoPostFix": "",
			"sSearch": "Buscar:",
			"sUrl": "",
			"sInfoThousands": ",",
			"sLoadingRecords": "Cargando...",
			"oPaginate": {
				"sFirst": "Primero",
				"sLast": "Último",
				"sNext": "Siguiente",
				"sPrevious": "Anterior"
			},
			"oAria": {
				"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
				"sSortDescending": ": Activar para ordenar la columna de manera descendente"
			}
		}
	});

	// Ajax dtable (Solicitud de materiales) - Start
	var TableRequests = $("#TableRequests");
	var TableRequests_no_approved = $("#TableRequests_no_approved");
	var TableRequests_status = $("input.request_status").val();
	if (TableRequests.length){
		$("#TableRequests").DataTable({
			"processing": true,
			"serverSide": true,
			"ajax":{
						"url": "/getrequests",
						"dataType": "json",
						"type": "POST",
						"data":{ _token: main_token,
									request_status: TableRequests_status,
									TableRequests_no_approved: 0}
					},
			"columns": [
					{ "data": "id" },
					{ "data": "author" },
					{ "data": "request_date" },
					{ "data": "contract_number" },
					{ "data": "warehouse", 	'name': 'requests.warehouse.name' },
					{ "data": "materials" },
					{ "data": "approver" },
					{ "data": "rejector" },
					{ "data": "status" },
					{ "data": "options" },
			],
			responsive:true,
			order:[0,'desc'],
			columnDefs: [
				{
					targets: $("#TableRequests").data("dtable-ignore")
						? $("#TableRequests").data("dtable-ignore")
						: [],
					orderable: false
				}
			],
			ordering: true,
			lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
			lengthChange: true,
			language: {
				"sProcessing": "Procesando...",
				"sLengthMenu": "Mostrar _MENU_ registros",
				"sZeroRecords": "No se encontraron resultados",
				"sEmptyTable": "Ningún dato disponible en esta tabla",
				"sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix": "",
				"sSearch": "Buscar:",
				"sUrl": "",
				"sInfoThousands": ",",
				"sLoadingRecords": "Cargando...",
				"oPaginate": {
					"sFirst": "Primero",
					"sLast": "Último",
					"sNext": "Siguiente",
					"sPrevious": "Anterior"
				},
				"oAria": {
					"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
					"sSortDescending": ": Activar para ordenar la columna de manera descendente"
				}
			},
			"initComplete": function(settings, json) {
				console.log("terminó y ahora inicia tooltip");

				$('span[data-toggle="tooltip"]').tooltip();
			}
		});
	}
	if (TableRequests_no_approved.length){
		$("#TableRequests_no_approved").DataTable({
			// paging: true,
			// lengthMenu: [[15, 30, 50, 100, -1], [15, 30, 50, 100, "Todos"]],
			// searching: true,
			"processing": true,
			"serverSide": true,
			"ajax":{
						"url": "/getrequests",
						"dataType": "json",
						"type": "POST",
						"data":{ _token: main_token,
									request_status: TableRequests_status,
									TableRequests_no_approved: 1}
					},
			"columns": [
					{ "data": "id" },
					{ "data": "author" },
					{ "data": "request_date" },
					{ "data": "contract_number" },
					{ "data": "warehouse", 	'name': 'requests.warehouse.name' },
					{ "data": "materials" },
					{ "data": "approver" },
					{ "data": "rejector" },
					{ "data": "status" },
					{ "data": "options" },

			],
			responsive:true,
			order:[0,'desc'],
			columnDefs: [
				{
					targets: $("#TableRequests_no_approved").data("dtable-ignore")
						? $("#TableRequests_no_approved").data("dtable-ignore")
						: [],
					orderable: false
				}
			],
			ordering: true,
			lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
			lengthChange: true,
			language: {
				"sProcessing": "Procesando...",
				"sLengthMenu": "Mostrar _MENU_ registros",
				"sZeroRecords": "No se encontraron resultados",
				"sEmptyTable": "Ningún dato disponible en esta tabla",
				"sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix": "",
				"sSearch": "Buscar:",
				"sUrl": "",
				"sInfoThousands": ",",
				"sLoadingRecords": "Cargando...",
				"oPaginate": {
					"sFirst": "Primero",
					"sLast": "Último",
					"sNext": "Siguiente",
					"sPrevious": "Anterior"
				},
				"oAria": {
					"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
					"sSortDescending": ": Activar para ordenar la columna de manera descendente"
				}
			},
			"initComplete": function(settings, json) {
				console.log("terminó y ahora inicia tooltip");

				$('span[data-toggle="tooltip"]').tooltip();
			}
		});
	}

	$(document).on('click', '#TableRequests .delete_action, #TableRequests_no_approved .delete_action', function() {
		if (confirm("Está seguro de eliminar?"))
			var tr_target = $(this).parents("tr");
			let id_request = $(this).data("target");
			let token = $( "input[name='_token']" ).val();
			let data = {
				'_token' : token
			}
			let url = "/requests/delete/" + id_request;
			$.post(url, data, function(response){
				tr_target.hide()
			});
		return false;
	});

	$(document).on('click', '.btn_restore', function() {
		if (confirm("Restaurar Solicitud?"))
			var tr_target = $(this).parents("tr");
			let id_request = $(this).data("target");
			let token = $( "input[name='_token']" ).val();
			let data = {
				'_token' : token
			}
			let url = "/requests/restore/" + id_request;
			$.post(url, data, function(response){
				tr_target.hide()
			});
		return false;
	});
	// Ajax dtable (Solicitud de materiales) - End

	// Ajax dtable purchase requests - Start
	$("#TablePurchaseIncomplete").DataTable({
		"processing": true,
		"serverSide": true,
		"pageLength": 30,
		"ajax":{
					"url": "/purchase-requests/byajax",
					"dataType": "json",
					"type": "POST",
					"data":{ _token: main_token,
								incomplete: true}
				},
		"columns": [
				{ "data": "id" },
				{ "data": "created_at" },
				{ "data": "request_material" },
				{ "data": "warehouse" },
				{ "data": "materials" },
				{ "data": "options" },
		],
		"createdRow": function( row, data, dataIndex ) {
			$(row).addClass( 'bg-error' );
		},
		responsive:true,
		order:[0,'desc'],
		columnDefs: [
			{
				targets: $("#TablePurchaseIncomplete").data("dtable-ignore")
					? $("#TablePurchaseIncomplete").data("dtable-ignore")
					: [],
				orderable: false
			}
		],
		ordering: true,
		lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
		lengthChange: true,
		language: {
			"sProcessing": "Procesando...",
			"sLengthMenu": "Mostrar _MENU_ registros",
			"sZeroRecords": "No se encontraron resultados",
			"sEmptyTable": "Ningún dato disponible en esta tabla",
			"sInfo": "Registros del _START_ al _END_ de _TOTAL_",
			"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
			"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
			"sInfoPostFix": "",
			"sSearch": "Buscar:",
			"sUrl": "",
			"sInfoThousands": ",",
			"sLoadingRecords": "Cargando...",
			"oPaginate": {
				"sFirst": "Primero",
				"sLast": "Último",
				"sNext": "Siguiente",
				"sPrevious": "Anterior"
			},
			"oAria": {
				"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
				"sSortDescending": ": Activar para ordenar la columna de manera descendente"
			}
		},
		"initComplete": function(settings, json) {
			$('[data-toggle="tooltip"]').tooltip();
		}
	});
	$("#TablePurchase").DataTable({
		"processing": true,
		"serverSide": true,
		"pageLength": 30,
		"ajax":{
					"url": "/purchase-requests/byajax",
					"dataType": "json",
					"type": "POST",
					"data":{ _token: main_token}
				},
		"columns": [
				{ "data": "id" },
				{ "data": "created_at" },
				{ "data": "request_material" },
				{ "data": "warehouse" },
				{ "data": "materials" },
				{ "data": "options" },
		],
		responsive:true,
		order:[0,'desc'],
		columnDefs: [
			{
				targets: $("#TablePurchase").data("dtable-ignore")
					? $("#TablePurchase").data("dtable-ignore")
					: [],
				orderable: false
			}
		],
		ordering: true,
		lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
		lengthChange: true,
		language: {
			"sProcessing": "Procesando...",
			"sLengthMenu": "Mostrar _MENU_ registros",
			"sZeroRecords": "No se encontraron resultados",
			"sEmptyTable": "Ningún dato disponible en esta tabla",
			"sInfo": "Registros del _START_ al _END_ de _TOTAL_",
			"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
			"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
			"sInfoPostFix": "",
			"sSearch": "Buscar:",
			"sUrl": "",
			"sInfoThousands": ",",
			"sLoadingRecords": "Cargando...",
			"oPaginate": {
				"sFirst": "Primero",
				"sLast": "Último",
				"sNext": "Siguiente",
				"sPrevious": "Anterior"
			},
			"oAria": {
				"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
				"sSortDescending": ": Activar para ordenar la columna de manera descendente"
			}
		},
		"initComplete": function(settings, json) {
			$('[data-toggle="tooltip"]').tooltip();
		}
	});
	$(document).on('click', '#TablePurchaseIncomplete .delete_action, #TablePurchase .delete_action', function() {
		if (confirm("Está seguro de eliminar?"))
			var tr_target = $(this).parents("tr");
			let id_request = $(this).data("target");
			let token = $( "input[name='_token']" ).val();
			let data = {
				'_token' : token
			}
			let url = "/purchase-requests/delete/" + id_request;
			$.post(url, data, function(response){
				tr_target.hide()
			});
		return false;
	});
	// Ajax dtable purchase requests - End

	// Ajax dtable dispatch requests - start
	$("#DispatchTable").DataTable({
		"processing": true,
		"serverSide": true,
		"pageLength": 30,
		"ajax":{
					"url": "/dispatches-made/byajax",
					"dataType": "json",
					"type": "POST",
					"data":{ _token: main_token}
				},
		"columns": [
				{ "data": "id" },
				{ "data": "created_at" },
				{ "data": "request_material" },
				{ "data": "project" },
				{ "data": "warehouse" },
				{ "data": "items" },
				{ "data": "dispatch_document" },
				{ "data": "dispatch_document_stamped" },
				{ "data": "options" },
		],
		"createdRow": function( row, data, dataIndex ) {
			if ( data['dispatch_document_stamped'] == "No" ) {
				$(row).addClass( 'bg-error' );
			}
		},
		responsive:true,
		order:[0,'desc'],
		columnDefs: [
			{
				targets: $("#DispatchTable").data("dtable-ignore")
					? $("#DispatchTable").data("dtable-ignore")
					: [],
				orderable: false
			}
		],
		ordering: true,
		lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
		lengthChange: true,
		language: {
			"sProcessing": "Procesando...",
			"sLengthMenu": "Mostrar _MENU_ registros",
			"sZeroRecords": "No se encontraron resultados",
			"sEmptyTable": "Ningún dato disponible en esta tabla",
			"sInfo": "Registros del _START_ al _END_ de _TOTAL_",
			"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
			"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
			"sInfoPostFix": "",
			"sSearch": "Buscar:",
			"sUrl": "",
			"sInfoThousands": ",",
			"sLoadingRecords": "Cargando...",
			"oPaginate": {
				"sFirst": "Primero",
				"sLast": "Último",
				"sNext": "Siguiente",
				"sPrevious": "Anterior"
			},
			"oAria": {
				"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
				"sSortDescending": ": Activar para ordenar la columna de manera descendente"
			}
		},
		"initComplete": function(settings, json) {
			$('span[data-toggle="tooltip"]').tooltip();
		}
	});
	// Ajax dtable dispatch requests - start

	// Ajax dtable services requests - start
	$("#ServiceTable").DataTable({
		"processing": true,
		"serverSide": true,
		"pageLength": 30,
		"ajax":{
					"url": "/requests-services/byajax",
					"dataType": "json",
					"type": "POST",
					"data":{ _token: main_token}
				},
		"columns": [
				{ "data": "id" },
				{ "data": "author_name" },
				{ "data": "request_date" },
				{ "data": "project" },
				{ "data": "warehouse" },
				{ "data": "oc" },
				{ "data": "rejector" },
				{ "data": "status" },
				{ "data": "options" },
		],
		responsive:true,
		order:[0,'desc'],
		columnDefs: [
			{
				targets: $("#ServiceTable").data("dtable-ignore")
					? $("#ServiceTable").data("dtable-ignore")
					: [],
				orderable: false
			}
		],
		ordering: true,
		lengthMenu: [[25, 30, 50, 100], [25, 30, 50, 100]],
		lengthChange: true,
		language: {
			"sProcessing": "Procesando...",
			"sLengthMenu": "Mostrar _MENU_ registros",
			"sZeroRecords": "No se encontraron resultados",
			"sEmptyTable": "Ningún dato disponible en esta tabla",
			"sInfo": "Registros del _START_ al _END_ de _TOTAL_",
			"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
			"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
			"sInfoPostFix": "",
			"sSearch": "Buscar:",
			"sUrl": "",
			"sInfoThousands": ",",
			"sLoadingRecords": "Cargando...",
			"oPaginate": {
				"sFirst": "Primero",
				"sLast": "Último",
				"sNext": "Siguiente",
				"sPrevious": "Anterior"
			},
			"oAria": {
				"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
				"sSortDescending": ": Activar para ordenar la columna de manera descendente"
			}
		},
		"initComplete": function(settings, json) {
			$('[data-toggle="tooltip"]').tooltip();
		}
	});
	$(document).on('click', '#ServiceTable .delete_action', function() {
		if (confirm("Está seguro de eliminar?"))
			var tr_target = $(this).parents("tr");
			let id_request = $(this).data("target");
			let token = $( "input[name='_token']" ).val();
			let data = {
				'_token' : token
			}
			let url = "/requests-services/delete/" + id_request;
			$.post(url, data, function(response){
				tr_target.hide()
			});
		return false;
	});
	// Ajax dtable services requests - start

	$('select:not(.material_cbo)').select2({
		placeholder: " Seleccione opción",
	});

	$('.material_cbo').select2({
		placeholder: " Seleccione opción",
		tags: true
	});

	$(".datepicker").datepicker({
		format: "dd/mm/yyyy",
		todayHighlight: true,
		startDate: "-5y",
		language: "es",
		autoclose: true
	});

	$(document).on('click', '.btn_del_action', function() {
		if (confirm("Está seguro de eliminar este item?"))
			$(this)
				.closest("form")
				.submit();
		return false;
	});


	//Warning aprobar y enviar solicitud
	$(".approve_request_btn").click(function() {
		if (confirm("Está seguro de aprobar y enviar esta solicitud? Si continúa, será enviada a Bodega central.")){
			$(this).text("Enviando...");
			$(this).attr('disabled', 'disabled');
			$(this).closest("form").submit();
			return false;
		}
		return false;
	});

	$(".btn_cancel_action").click(function() {
		if (confirm("Está seguro de cancelar esta operación?")) return true;
		return false;
	});

	$("#role").change(function(){
		console.log('change');


		var role_id = $(this).val();
		if(role_id==5){ //admin faena
			$(".list_projects").show();
			$(".cbo_projects").removeClass("is_grocer");
			$(".cbo_warehouses").hide();
		}else if(role_id==6){//bod faena
			$(".list_projects").show();
			$(".cbo_projects").addClass("is_grocer");
		}else{
			$(".list_projects").hide();
			$(".cbo_warehouses").hide();
			$(".cbo_projects").removeClass("is_grocer");
			$(".cbo_warehouses").hide();
		}
	});

	$(".list_projects").on("change",".cbo_projects.is_grocer", function(){
		var options = "";
		var projects_id = $(this).val();
		$("#warehouses_id").empty().append("<option value>Seleccione Bodegas</option>");
		$("#warehouses_id").attr('disabled', 'disabled');
		if(projects_id){
			var url = "/projects/getwarehouses";
			let params = {
				'projects' : projects_id,
				'_token' : $( "input[name='_token']" ).val()
			}

			$.post(url, params, function(response){
				$.each(response, function (index, warehouses) {
			  		options = options + '<option value="' + warehouses['id'] +'">' + warehouses['name'] + '</option>';
				});
				$("#warehouses_id").append(options);
				$("#warehouses_id").removeAttr('disabled');
				$(".cbo_warehouses").show();
			});

		}
	});

	/* obtener bodegas por proyecto para llenar cbo de bodegas */

	$(".project_ajax #project_id").change(function(){
		//crear un array con todos los valores del cbo y mandarlo al metodo para que devuelva las bodegas disponibles para esos proyectos
		var project_id = $(this).val();
		getSingleWarehousesByProject(project_id);
	});

	function getSingleWarehousesByProject(project_id){
		var options= "";
		$("#warehouse_id").empty().append("<option value>Seleccione Bodega</option>");
		$("#warehouse_id").attr('disabled', 'disabled');
		if(project_id){
			var url = "/projects/" + project_id + "/warehouses";
			var token = $( "input[name='_token']" ).val();
			$.post(url, {_token:token,ajax:true}, function(response){
				$.each(response, function (index, warehouse) {
			  		options = options + '<option value="' + warehouse['id'] +'">' + warehouse['name'] + '</option>';
				});
				$("#warehouse_id").append(options);
				$("#warehouse_id").removeAttr('disabled');
			});
		}
	}



	/* rellenar cbo grupos materiales */
	$("#group_parent").change(function(){
		var group_id = $(this).val();
		var options= "";
		if(group_id){
			$("#group_id").empty().append("<option value>Seleccione Subgrupo</option>");
			$("#group_id").attr('disabled', 'disabled');
			var url = "/materials/groups/childs/" + group_id;
			var token = $( "input[name='_token']" ).val();
			$.post(url, {_token:token,ajax:true}, function(response){
				$.each(response, function (index, group) {
			  		options = options + '<option value="' + group['id'] +'">(' + group['code'] + ') '+ group['description'] +'</option>';
				});
				$("#group_id").append(options);
				$("#group_id").removeAttr('disabled');
			});
		}
	});

	/* prevenir auto guardado, el form debe tener clase .form y el boton guardar clase .btn_save */
	var send_btn = false;
	$(".form").on("submit",function(){
		var btn = $(this).find(".btn_save");
		if(!send_btn){
			send_btn = true;
			btn.text("Guardando...");
			btn.attr('disabled', 'disabled');
			return true;
		}else{
			return false;
		}
	});


	/** Agregar items a la solicitud */
	var item_count = parseInt($("#item_count_request").val());
	$(".add_item").click(function() {
		var url = "/requests/materials/";
		item_count = item_count + 1;
		$.get(url, { item_count: item_count }, function(response) {

			$(".items_container").append(response);
			$.each($(".items_container select"), function() {
				$(this).select2({
					placeholder: " Seleccione opción",
					tags: true
				});
			});
		});
		return false;
	});
	/** Eliminar items del detalle de solicitud */
	$(".items_container").on("click", ".del_item", function() {
		var id = $(this).data("id");
		console.log('del_item',id);


		$("#item_row_" + id).remove();
		return false;
	});


	/**cambia item material -> actualiza unidad de medida */
	$(".items_container").on("change", ".item_select", function(e){
		var cbo = $(this);
		var material_id = cbo.val();
		if(isNaN(material_id)){
			//creo nuevo material y devuelve uom
			cbo.parent().find(".item_is_new").val("1");
			cbo.parent().parent().parent().find(".item_uom").empty();
		}else{
			//obtener uom
			var url = "/materials/" + material_id + "/uom";
			$.get(url, { }, function(response) {
				if(response!=0){
					cbo.parent().find(".item_is_new").val("0");
					cbo.parent().parent().parent().find(".item_uom").empty().append(response);
				}else{
					cbo.parent().find(".item_is_new").val("1");
					cbo.parent().parent().parent().find(".item_uom").empty();
				}
			});
		}

	});

	/** Eliminar archivos de la solicitud */
	$(".archives_list").on("click", ".del_archive", function() {
		var id = $(this).data("id");
		$("#request_archive_" + id).remove();
		return false;
	});

	/** Enviar form para aprobar solicitud desde edicion de solicitud  */
	$("#ApproveRequest_from_edit_btn").click(function(){
		$("#ApproveRequest_from_edit").submit();
	});


	/** Editar materiales de la solicitud cuando lo ve Bodega central */
	$(".edit_material_inline").click(function(){
		$(".edit_material_inline_default").hide();
		$(".edit_material_inline_form").show();
	});

	$(".cancel_material_inline").click(function(){
		$(".edit_material_inline_default").show();
		$(".edit_material_inline_form").hide();
	});

	/** Bodega central cuando recibe una solicitud de materiales, debe agregar existencias a despacho*/
	/** Agregar items al despacho */
	let first_time = true;
	let item_q = 0;
	let item_max = 21;
	$(".list_items_bc").on("click", ".add_to_dispatch", function() {
		let id = $(this).data("id");
		let material_item = $(".request_material_item_"+id);
		let material_id = material_item.find(".request_material_item_id").val();
		let material_name = material_item.find(".request_material_item_name").val();
		let material_code = material_item.find(".request_material_item_code").val();
		let uom = material_item.find(".request_material_item_uom").val();
		let quantity_current = parseInt(material_item.find(".request_material_item_quantity").val());
		let quantity = parseInt(material_item.find(".stock_item_request").val());
		let error_msg = material_item.find(".error_msg");
		let add_to_dispatch_value = material_item.find(".add_to_dispatch_value");
		let add_to_dispatch_value_txt = material_item.find(".add_to_dispatch_value span");
		let add_to_dispatch_form = material_item.find(".add_to_dispatch_form");
		error_msg.empty();

		//si la cantidad a despachar es mayor a 0 y no supera la cantidad solicitada o la cantidad que queda por despachar
		if(quantity > 0 && quantity <= quantity_current){
			//ingreso en Despacho
			//verificar si existe
			if(!$('#dispatch_item_'+id).length){

				//permite solo un maximo de 21 items en el despacho
				if(item_q == item_max){
					error_msg.empty().append("No puedes agregar más items a esta solicitud (máximo "+item_max+")");
					return false;
				}
				item_q = item_q + 1;

				let tr =
					'<tr class="dispatch_item" id="dispatch_item_'+id+'">' +
						'<td>' + material_name + '</td>' +
						'<td>' + quantity + ' ' + uom + '</td>' +
						'<td>' +
							'<a href="#" class="color-red del_dispatch_item" data-id="'+id+'"><i class="fa fa-times"></i></a>' +
							'<input type="hidden" name="dispatch_item_quantity[]" class="dispatch_item_quantity" value="'+quantity+'">' +
							'<input type="hidden" name="dispatch_item_id[]" class="dispatch_item_id" value="'+id+'">' +
							'<input type="hidden" name="dispatch_item_name[]" class="dispatch_item_name" value="'+material_name+'">' +
							'<input type="hidden" name="dispatch_item_material_id[]" class="dispatch_item_material_id" value="'+material_id+'">' +
						'</td>' +
					'</tr>';
				$(".dispatch_request_items table tbody").append(tr);
				add_to_dispatch_form.hide();
				add_to_dispatch_value_txt.empty().append(quantity + " " + uom);
				add_to_dispatch_value.show();
				resize_new_dispatch_request();

				if(quantity<quantity_current){
					let quantity_purchase = quantity_current - quantity;
					tr =
						'<tr id="purchase_item_'+id+'">' +
							'<td>' + material_name + '</td>' +
							'<td>' +
								'<div class="input-group cover_purchase_item_quantity">' +
									'<input type="text" class="form-control purchase_item_quantity input-sm" name="purchase_item_quantity[]" value="'+quantity_purchase+'">' +
									'<span class="input-group-addon bg-gray-light item_uom">'+uom+'</span>' +
								'</div>'+
							'</td>' +
							'<td>' +
								'<a href="#" class="color-red del_purchase_item" data-id="'+id+'"><i class="fa fa-times"></i></a>' +
								'<input type="hidden" name="purchase_item_id[]" class="purchase_item_id" value="'+id+'">' +
								'<input type="hidden" name="purchase_item_material_id[]" class="purchase_item_material_id" value="'+material_id+'">' +
							'</td>' +
						'</tr>';
					if(first_time){
						first_time = false;
						$(".purchase_request_items table tbody").empty();
					}
					$(".purchase_request_items table tbody").append(tr);
					$('.nav-tabs a[href="#NewPurchaseRequest"]').tab('show');

				}
			}else{
				error_msg.empty().append("El elemento ya fue agregado, elimínelo del detalle del Despacho y vuelva a agregarlo");
			}

		}else{
			error_msg.empty().append("La cantidad a despachar no puede ser superior a la cantidad que queda por enviar.");
		}

		return false;
	});

	//borrar archivo de despacho
	$(".archives_list").on("click", ".del_archive_dispatch", function() {
		var id = $(this).data("id");
		var type = $(this).data("type");
		$("#request_archive_" + id).remove();
		$("#add" + type).show();
		return false;
	});

	//borrar items de despacho
	$(".dispatch_request_items").on("click", ".del_dispatch_item", function() {
		let id = $(this).data("id");
		let material_item = $(".request_material_item_"+id);
		let add_to_dispatch_form = material_item.find(".add_to_dispatch_form");
		let add_to_dispatch_value = material_item.find(".add_to_dispatch_value");
		add_to_dispatch_value.hide();
		add_to_dispatch_form.show();
		$("#dispatch_item_" + id).remove();
		$("#purchase_item_" + id).remove();
		//reduzco en 1 la cantidad de items seleccionados
		item_q = item_q - 1;
		return false;
	});

	//despachar materiales
	//MARCA EXISTENCIAS DE LOS ITEMS, YA NO SE DESPACHA DIRECTAMENTE, EL DESPACHO REAL ES POR DISPATCH MADE
	$(".dispatch_btn").click(function(){
		//desactivar boton
		const btn = $(this);
		btn.attr('disabled', 'disabled');
		btn.text("Procesando...");
		//get variables
		let request_id = $("#request_id").val();
		$(".dispatch_msg_error").empty();

		//arrays:
		let request_material_id = $(".dispatch_item_id").map(function(){return $(this).val();}).get();
		let quantity = $(".dispatch_item_quantity").map(function(){return $(this).val();}).get();
		let material_id = $(".dispatch_item_material_id").map(function(){return $(this).val();}).get();

		let token = $( "input[name='_token']" ).val();

		let data = {
			'_token' : token,
			'request_id' : request_id,
			'request_material_id[]' : request_material_id,
			'quantity[]' : quantity,
			'material_id[]' : material_id
		}

		if(request_material_id.length==0){
			$(".dispatch_msg_error").empty().append("Despacho sin items. No se puede enviar.");
			btn.removeAttr('disabled');
			btn.text("Confirmar existencias");
			$(".new_dispatch_request").height(0);
			return false;
		}

		let url = "/dispatch-requests";
		let current_dispatch_requests_list = $(".dispatch_requests_list").html();
		$(".dispatch_requests_list").empty().append("Actualizando...");
		$(".new_dispatch_request").height(0);

		$.post(url, data, function(response){
			$(".dispatch_request_items table tbody").empty();

			first_time = true;
			$(".dispatch_requests_list").empty().append(response);
			$('[data-toggle="tooltip"]').tooltip();

			//mostrar mensaje
			$(".dispatch_msg_ok").show().delay( 3000 ).fadeOut();

			//actualizar lista de materiales en request
			update_materiales_bc(request_id,token);

			//actualizar lista de materiales en new purchase request
			$("#NewPurchaseRequest").empty().append("Actualizando...");
			url = '/purchase-requests/create/' + request_id;
			$.get(url, {'_token' : token}, function(response){
				$("#NewPurchaseRequest").empty().append(response);
			});

			//actualizar lista de materiales en new dispatch made
			update_materials_new_dispatch_made(request_id,token);

			updateStatusRequest();

			//activar boton
			btn.removeAttr('disabled');
			btn.text("Confirmar existencias");
		})
		.fail(function(response) {
			$(".dispatch_requests_list").empty().append(current_dispatch_requests_list);
			resize_new_dispatch_request();
			if(response.responseJSON.errors.contractor_goods_document_number){
				$(".dispatch_msg_error").empty().append("El número de documento de la GBC ya existe");
			}
			if(response.responseJSON.errors.dispatch_document_number){
				$(".dispatch_msg_error").empty().append("El número de documento de la GD ya existe");
			}
			//activar boton
			btn.removeAttr('disabled');
			btn.text("Confirmar existencias");
		})

		return false;

	});

	//Despacho real items (Dispatch Made)
	$("#NewDispatchMade").on("click", ".dispatch_made_btn", function() {
		//get variables
		let request_id = $("#request_id").val();
		let gbc_number = $("#gbc_number").val();
		let gd_number = $("#gd_number").val();
		let gbc = $("input[name=GBC]");
		let gd = $("input[name=GD]");
		$(".dispatch_made_msg_error").empty();

		let btn = $(".dispatch_made_btn");
		btn.attr('disabled', 'disabled');
		btn.text("Procesando...");

		//arrays:
		let request_material_id = $(".request_material_id").map(function(){return $(this).val();}).get();
		let dispatch_request_material_id = $(".dispatch_request_material_id").map(function(){return $(this).val();}).get();
		let dispatch_request_id = $(".dispatch_request_id").map(function(){return $(this).val();}).get();
		let quantity = $(".dispatch_made_item_quantity").map(function(){return $(this).val();}).get();
		let material_id = $(".dispatch_made_item_material_id").map(function(){return $(this).val();}).get();

		let token = $( "input[name='_token']" ).val();

		let data = {
			'_token' : token,
			'request_id' : request_id,
			'gbc' : gbc.val(),
			'gd' : gd.val(),
			'contractor_goods_document_number' : gbc_number,
			'dispatch_document_number' : gd_number,
			'dispatch_request_id[]' : dispatch_request_id,
			'request_material_id[]' : request_material_id,
			'dispatch_request_material_id[]' : dispatch_request_material_id,
			'quantity[]' : quantity,
			'material_id[]' : material_id
		}

		//verificar si ingreso el numero de documento
		var aux_documents = false;

		if(gbc_number.length>0){
			aux_documents = true;
		}

		if(gd_number.length>0){
			aux_documents = true;
		}


		if(request_material_id.length==0){
			$(".dispatch_made_msg_error").empty().append("Despacho sin items. No se puede enviar.");
			btn.removeAttr('disabled');
			btn.text("Realizar Despacho");
			return false;
		}

		if(aux_documents){
			//verificar si ha subido al menos 1 de los dos archivos
			let url = "/dispatches-made";
			let current_dispatch_made_list = $(".dispatches_made_list").html();
			$(".dispatches_made_list").empty().append("Actualizando...");
			//$(".new_dispatch_made").height(0);

			$.post(url, data, function(response){
				$(".new_dispatch_made_items table tbody").empty();
				$("#addGBC").show();
				$("#addGD").show();
				$(".file_gbc").empty();
				$(".file_gd").empty();
				$("#gbc_number").val("");
				$("#gd_number").val("");

				first_time = true;
				$(".dispatches_made_list").empty().append(response);
				$('[data-toggle="tooltip"]').tooltip();

				//mostrar mensaje
				$(".dispatch_made_msg_ok").show().delay( 3000 ).fadeOut();

				//actualizar lista de materiales en request
				update_materiales_bc(request_id,token);

				//actualizar lista de materiales en new dispatch made
				update_materials_new_dispatch_made(request_id,token);

				//actualizar status request
				updateStatusRequest();

				btn.removeAttr('disabled');
				btn.text("Realizar Despacho");
			})
			.fail(function(response) {
				$(".dispatches_made_list").empty().append(current_dispatch_made_list);
				if(response.responseJSON.errors.contractor_goods_document_number){
					$(".dispatch_made_msg_error").empty().append("El número de documento de la GBC ya existe");
				}
				if(response.responseJSON.errors.dispatch_document_number){
					$(".dispatch_made_msg_error").empty().append("El número de documento de la GD ya existe");
				}
				btn.removeAttr('disabled');
				btn.text("Realizar Despacho");
			})

		}else{
			$(".dispatch_made_msg_error").empty().append("Debes ingresar al menos un número de documento");
			btn.removeAttr('disabled');
			btn.text("Realizar Despacho");
		}

		return false;

	});
	//Fin despacho real items.. dispatch made

	//Nueva solicitud de compra
	$("#NewPurchaseRequest").on("click", ".purchase_btn", function() {
		let btn = $(this);
		btn.attr('disabled', 'disabled');
		//get variables
		let request_id = $("#request_id").val();
		$(".purchase_msg_error").empty();

		//arrays:
		let request_material_id = $(".purchase_item_id").map(function(){return $(this).val();}).get();
		let quantity = $(".purchase_item_quantity").map(function(){return $(this).val();}).get();
		let material_id = $(".purchase_item_material_id").map(function(){return $(this).val();}).get();

		let token = $( "input[name='_token']" ).val();

		let data = {
			'_token' : token,
			'request_id' : request_id,
			'request_material_id[]' : request_material_id,
			'quantity[]' : quantity,
			'material_id[]' : material_id
		}

		if(request_material_id.length>0){
			let url = "/purchase-requests";
			$(".purchase_requests_list").empty().append("Actualizando...");
			$.post(url, data, function(response){
				$(".purchase_requests_list").empty().append(response);
				$('.nav-tabs a[href="#PurchaseRequests"]').tab('show');
				btn.removeAttr('disabled');
				$('[data-toggle="tooltip"]').tooltip();
				updateStatusRequest();
			});
		}else{
			$(".purchase_msg_error").empty().append("Solicitud sin items. No se puede enviar.")
		}
		return false;
	});

	//borrar items de sol compra
	$("#NewPurchaseRequest").on("click", ".del_purchase_item", function() {
		let id = $(this).data("id");
		$("#purchase_item_" + id).remove();
		return false;
	});

	//borrar items de new dispatch made
	$("#NewDispatchMade").on("click", ".del_dispatch_made_item", function() {
		let id = $(this).data("id");
		$("#dispatch_made_item_" + id).remove();
		return false;
	});

	//refrescar sol de compra
	$("#NewPurchaseRequest").on("click", ".refresh_new_purchase", function() {
		let request_id = $("#request_id").val();
		refresh_new_purchase_request(request_id);
	});

	function refresh_new_purchase_request(id_request){
		let url = "/purchase-requests/create/" + id_request;
		let data = {'_token' : $( "input[name='_token']" ).val()}
		$.get(url, data, function(response){
			$("#NewPurchaseRequest").empty().append(response);
		});
		return false;
	}

	//seleccionar items en solicitud de compra para poder cargar la OC.
	$(".purchase_request_items_list").on("click", ".check_items_purchase", function() {
		let id = $(this).data("id");
		let name = $(this).data("name");

		if($(this).prop('checked')){
			let li =
				'<li id="list_purchase_items_oc_'+id+'">' +
					name +
				'</li>';
			let hdn = '<input type="hidden" id="hdn_list_purchase_items_oc_'+id+'" name="item_purchase_selected[]" value="'+id+'">';
			$(".list_purchase_items_oc").append(li);
			$(".list_purchase_items_oc_hiddens").append(hdn);
		}else{
			$("#list_purchase_items_oc_"+id).remove();
			$("#hdn_list_purchase_items_oc_"+id).remove();
		}
	});

	//Rechazar compra de item
	$(".purchase_request_items_list").on("click",".btn_reject_purchase_item", function(){
		let id = $(this).data("id");
		let comment = $("#comment_"+id).val();


		if (confirm("Está seguro de rechazar este item?")){
			if(comment.length > 0) {
				let token = $( "input[name='_token']" ).val();
				let data = {
					'_token' : token,
					'purchase_request_item_id' : id,
					'comment' : comment
				}
				let url = "/purchase-requests/reject";
				$(".purchase_request_items_list").empty().append("Actualizando...");
				$.post(url, data, function(response){
					$(".purchase_request_items_list").empty().append(response);
					$('[data-toggle="tooltip"]').tooltip();

					estado = $(response).find('.table');

					if (estado.prevObject[0].classList.contains('hidden_status')){
						$(".label-status .label").empty().addClass('label-success').append('Solicitud cerrada');
						$('.approve_purchase_request').hide();
					}else{
						$(".label-status .label").empty().removeClass('label-success').addClass('label-info').append('Solicitud en proceso');
						$('.approve_purchase_request').show();
					}
				});
			}
		}
		return false;
	});



	//Cancelar Rechazo de compra de item
	$(".purchase_request_items_list").on("click",".cancel_reject", function(){
		if (confirm("Está seguro de cancelar el rechazo?")){
			let id = $(this).data("id");
			let token = $( "input[name='_token']" ).val();
			let data = {
				'_token' : token,
				'purchase_request_item_id' : id
			}
			let url = "/purchase-requests/reject/cancel";
			$(".purchase_request_items_list").empty().append("Actualizando...");
			$.post(url, data, function(response){
				$(".purchase_request_items_list").empty().append(response);
				$('[data-toggle="tooltip"]').tooltip();
				estado = $(response).find('.table');

				if (estado.prevObject[0].classList.contains('hidden_status')) {
					$(".label-status .label").empty().addClass('label-success').append('Solicitud cerrada');
					$('.approve_purchase_request').hide();
				} else {
					$(".label-status .label").empty().removeClass('label-success').addClass('label-info').append('Solicitud en proceso');
					$('.approve_purchase_request').show();
				}
			});
		}
		return false;
	});

	//confirmar recepcion de despacho
	let confirm_dispatch_made_btn_action = false;
	$(".confirm_dispatch_made_btn").click(function(){
		if(!confirm_dispatch_made_btn_action){
			confirm_dispatch_made_btn_action= true;
			let id = $(this).data("id");
			let gbc = $("input[name=GBC]");
			let gd = $("input[name=GD]");
			let request_material_id = $("#request_material_id").val();
			let token = $( "input[name='_token']" ).val();
			let url = "/dispatches-made/confirm";
			let btn = $(this);
			btn.attr('disabled', 'disabled');
			btn.text("Enviando...");

			let data = {
				'_token' : token,
				'dispatch_made_id' : id,
				'request_material_id' : request_material_id,
				'gbc' : gbc.val(),
				'gd' : gd.val()
			}

			$(".dispatch_made_msg_error").empty();
			if(gbc.length || gd.length){
				$.post(url, data, function(response){
					$(".confirm_dispatch").empty().append(response);
					$(".dispatch_made_msg_success").empty().append("Recepción de materiales confirmada correctamente").show().delay( 3000 ).fadeOut();;
				});
			}else{
				btn.removeAttr('disabled');
				btn.text("Confirmar Entrega de materiales");
				confirm_dispatch_made_btn_action= false;
				$(".dispatch_made_msg_error").empty().append("Debe subir al menos 1 documento timbrado.");
			}
		}
	});

	$(".dispatch-refuse").click(function(){
		let dispatch_id = $(this).data("dispatch");
		$("#modal-refuseD .dispatch-request_id").attr('value', dispatch_id);
	});

	$(".description-gbc").keypress(function() {
		let id = $(this).data("id");
		let l = parseInt($(this).val().length);
		if(l==64){
			$("#description-" + (parseInt(id)+1)).focus();
		}
	});

	$('#GBCGenerator').on('show.bs.modal', function() {
		//limpiar actual GBC form
		$.each($(".description-gbc"), function (i, e) {
			$(".gbc_item_number_"+(i+1)).val("");
			$(".gbc_item_quantity_"+(i+1)).val("");
			$(".gbc_item_name_"+(i+1)).val("");
		});

		let dispatch_made_item_name = $(".dispatch_made_item_name").map(function(){return $(this).val();}).get();
		let dispatch_made_item_quantity = $(".dispatch_made_item_quantity").map(function(){return $(this).val();}).get();
		dispatch_made_item_name.forEach(function(e,i) {
			$(".gbc_item_number_"+(i+1)).val(i+1);
			$(".gbc_item_quantity_"+(i+1)).val(dispatch_made_item_quantity[i]);
			$(".gbc_item_name_"+(i+1)).val(e);
		});
	})


	//Agregar comentario al request
	$(".add_comment_to_request").click(function(){
		let btn = $(this);
		btn.attr('disabled', 'disabled');
		let msg = $(".new_message_request");
		let request_id = $(this).data("request-id");
		let token = $( "input[name='_token']" ).val();
		let data = {
			'_token' : token,
			'msg' : msg.val()
		}
		let url = "/request/"+request_id+"/message";
		$.post(url, data, function(response){
			$(".list_request_messages").empty().append(response);
			btn.removeAttr('disabled');
			msg.val("");
		});
		return false;
	});

	//borrar mensajes de request
	$(".list_request_messages").on("click",".delete_request_message", function(){
		if (!confirm("Está seguro de eliminar este comentario?"))	return false;
		let id_request_message = $(this).data("id-message");
		let token = $( "input[name='_token']" ).val();
		let data = {
			'_token' : token
		}
		let url = "/request/delete/message/" + id_request_message;
		$.post(url, data, function(response){
			$(".list_request_messages").empty().append(response);
		});
		return false;
	});

	//Prevenir envio de formularios con Enter
	$(window).keydown(function(event){
		if(event.keyCode == 13) {
			event.preventDefault();
			return false;
		}
	});

});

//mostrar y rezise form de nuevo despacho
function resize_new_dispatch_request(){
	let h = $(".new_dispatch_request>div").outerHeight() + 10;
	$(".new_dispatch_request").height(h);
}

//actualizar status request del titulo
function updateStatusRequest(){
	let status = $(".status_request_view");
	let request_id = status.data("id");
	let token = $( "input[name='_token']" ).val();
	let url = '/requests/status/' + request_id;
	$.get(url, {'_token' : token}, function(response){
		let status_span = '<span class="label label-' + response.label + '">' + response.status + '</span>';
		status.empty().append(status_span);
	});
}

//actualizar lista de materiales en request
function update_materiales_bc(request_id,token){
	let url = '/request/' + request_id + ' /list-bc/';
	$(".list_items_bc").empty().append("Actualizando...");
	$.get(url, {'_token' : token}, function(response){
		$(".list_items_bc").empty().append(response);
	});
}

//actualizar lista de materiales en new dispatch made
function update_materials_new_dispatch_made(request_id,token){
	$("#NewDispatchMade").empty().append("Actualizando...");
	const url = '/dispatch-made/create/' + request_id;
	$.get(url, {'_token' : token}, function(response){
		$("#NewDispatchMade").empty().append(response);
		new Dropzone(addGD,Dropzone.options.addGD);
		new Dropzone(addGBC,Dropzone.options.addGBC);
	});
}


$.fn.dataTable.ext.errMode = 'throw';